import { useDebugStore } from '@/store/use-debug-store';
import { DebugLogEntry, DebugLogLevel } from '../types/debug.types';

export class DebugService {
  static log(level: DebugLogLevel, message: string, context?: Record<string, any>) {
    useDebugStore.getState().logWebSocketEvent({
      timestamp: new Date().toISOString(),
      level,
      message,
      context,
    });
  }

  static updateLastWebSocketTimestamp() {
    useDebugStore.getState().updateLastMessageTime();
  }

  static reset() {
    useDebugStore.getState().resetLogs();
  }
}

export const debugService = DebugService; 